import type { Task } from '@medplum/fhirtypes';

function isAppointmentReference(ref?: string): boolean {
  return Boolean(ref?.startsWith('Appointment/'));
}

function appointmentIdFromReference(ref: string): string {
  return ref.slice('Appointment/'.length);
}

/**
 * Returns the Appointment id when a Task explicitly references one via FHIR
 * references (basedOn, reasonReference, input valueReference, or focus).
 * Does not parse portal JSON inputs (e.g. proposedAppointmentId).
 */
export function getTaskLinkedAppointmentId(task: Task): string | undefined {
  for (const based of task.basedOn ?? []) {
    if (isAppointmentReference(based.reference)) {
      return appointmentIdFromReference(based.reference!);
    }
  }

  const reasonRef = task.reasonReference?.reference;
  if (isAppointmentReference(reasonRef)) {
    return appointmentIdFromReference(reasonRef!);
  }

  for (const input of task.input ?? []) {
    const ref = input.valueReference?.reference;
    if (isAppointmentReference(ref)) {
      return appointmentIdFromReference(ref!);
    }
  }

  const focusRef = task.focus?.reference;
  if (isAppointmentReference(focusRef)) {
    return appointmentIdFromReference(focusRef!);
  }

  return undefined;
}

export function taskHasLinkedAppointment(task: Task): boolean {
  return getTaskLinkedAppointmentId(task) !== undefined;
}
